module.exports = __webpack_public_path__ + "1_logo_jewellry_old_version_maroon_rovcanin_white.jpg?50bb687ada4fdee7dd8f27b4ecabad00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/1_logo_jewellry_old_version_maroon_rovcanin_white.jpg
// module id = 87
// module chunks = 0